<template>
    <div class="single-circle-graph relative" data-cy="container_single_circle_graph" :style="{ width: size + 'px', height: size + 'px' }">
        <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`">
            <!-- Background Circle -->
            <circle
                :cx="center"
                :cy="center"
                :r="radius"
                fill="none"
                :stroke="backgroundColor"
                :stroke-width="strokeWidth"
            />
            <!-- Progress Circle -->
            <circle
                :cx="center"
                :cy="center"
                :r="radius"
                fill="none"
                :stroke="color"
                :stroke-width="strokeWidth"
                :stroke-dasharray="circumference"
                :stroke-dashoffset="progressOffset"
                :stroke-linecap="strokeLinecap"
                :transform="`rotate(-90 ${center} ${center})`"
                class="transition-all duration-700 ease-out"
            />
        </svg>
        <!-- Center Content -->
        <div class="absolute inset-0 flex flex-col items-center justify-center" data-cy="text_single_circle_graph_score">
            <span class="text-a-black font-bold" :style="{ fontSize: scoreFontSize + 'px' }" data-cy="text_single_circle_graph_score_value">
                {{ score }} 
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "SingleCircleGraph",
    props: {
        // Current score
        score: {
            type: Number,
            default: 0
        },
        // Maximum score
        maxScore: {
            type: Number,
            default: 100
        },
        // SVG size
        size: {
            type: Number,
            default: 120
        },
        // Stroke width
        strokeWidth: {
            type: Number,
            default: 10
        },
        // Progress color
        color: {
            type: String,
            default: '#0064ff'
        },
        // Background color
        backgroundColor: {
            type: String,
            default: '#e8eaed'
        },
        // Stroke line cap
        strokeLinecap: {
            type: String,
            default: 'butt'
        },
        // Font size for score
        scoreFontSize: {
            type: Number,
            default: 32
        }
    },
    computed: {
        center() {
            return this.size / 2;
        },
        radius() {
            return (this.size - this.strokeWidth) / 2;
        },
        circumference() {
            return 2 * Math.PI * this.radius;
        },
        progressOffset() {
            const percentage = this.score / this.maxScore;
            return this.circumference * (1 - percentage);
        }
    }
};
</script>
